export enum CURRENCY_ENUM {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  AED = 'AED',
}

export const ALLOWED_CURRENCIES = Object.values(CURRENCY_ENUM);
